/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.3.6
 */

export type EventRegistrationFormFieldType = typeof EventRegistrationFormFieldType[keyof typeof EventRegistrationFormFieldType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventRegistrationFormFieldType = {
  SINGLE_LINE: 'SINGLE_LINE',
  MULTI_LINE: 'MULTI_LINE',
  DATE: 'DATE',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  INFO: 'INFO',
  SPACE: 'SPACE',
  UPLOAD: 'UPLOAD',
} as const;
